import React from "react";
import { IWebsiteBuilderSectionEntityViewBoundingBox } from "../../hooks/sectionEntity/helpers/sectionEntityViewBoundingBox";
import { SectionEntityFrameSelection } from "./SectionEntityFrameSelection";
import { TWebsiteBuilderSectionEntityViewContext } from "../../hooks/sectionEntity/helpers/sectionEntityViewContext";
import { SectionEntityFrameHighlightTitle } from "./SectionEntityFrameHighlightTitle";
import { SectionEntityFrameHighlight } from "./SectionEntityFrameHighlight";
import { SectionEntityFrameResizeHandles } from "./SectionEntityFrameResizeHandles";

export type TSectionEntityFrameHighlight = "none" | "weak" | "strong";

interface ISectionEntityFrameProps {
  context: TWebsiteBuilderSectionEntityViewContext;
  title: string;
  highlight: TSectionEntityFrameHighlight;
  boundingBox: IWebsiteBuilderSectionEntityViewBoundingBox;
  selected: boolean;
  moving: boolean;
  viewResizeHandles: JSX.Element;
}

export function SectionEntityFrame(props: ISectionEntityFrameProps) {
  const { context, title, highlight, boundingBox, selected, moving, viewResizeHandles } = props;

  return (
    <>
      <SectionEntityFrameHighlightTitle
        context={context}
        title={title}
        highlight={highlight}
        boundingBox={boundingBox}
      />
      <SectionEntityFrameHighlight
        highlight={highlight}
        boundingBox={boundingBox}
      />
      <SectionEntityFrameSelection
        selected={selected}
        boundingBox={boundingBox}
      />
      <SectionEntityFrameResizeHandles
        selected={selected}
        moving={moving}
        boundingBox={boundingBox}
        viewResizeHandles={viewResizeHandles}
      />
    </>
  );
}